import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGet, apiPost } from "../../utils/api";

const NewsAdmin = () => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    async function exibir() {
      const payload = apiGet("/news");

      setNews((await payload).data.data);
    }

    exibir();
  }, []);

  function deleteNews(id) {
    deleteById(id).then(
      (payload) => {
        alert("Elemento removido!", "success");

        setNews(news.filter((item) => item.news_id !== id));
      },
      (error) => {
        let message = "Erro ao remover!";

        if (error.status === 401) {
          message = "Sem autorização.";
          // toLogin();
        }
        alert(message, "error");
      }
    );
  }

  async function deleteById(id) {
    const payload = apiPost("/news/delete/" + id);
    return await payload;
  }

  return (
    <div>
      <section id="management" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Gerenciamento das notícias</h2>
        </div>
      </section>

      <div>
        <Link className="btn btn-primary" to="/management/news/create">
          Cadastrar uma notícia
        </Link>
        &nbsp;&nbsp;&nbsp;
        <Link className="btn btn-secondary" to={"/management"}>
          Voltar
        </Link>
      </div>

      {news && news.length
        ? news.map((newww) => {
            return (
              <div className="row m-1 posts" key={newww.news_id}>
                <div className="card mb-3">
                  <div className="col-lg-12">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <b>Autor(a):</b>
                          </td>
                          <td>{newww.authors}</td>
                        </tr>
                        <tr>
                          <td>
                            <b>Título:</b>
                          </td>
                          <td>{newww.title}</td>
                        </tr>
                        <tr>
                          <td>
                            <b></b>
                          </td>
                          <td>
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={'/readmore/"' + newww.title + '"'}
                            >
                              Visualizar a notícia.
                            </a>
                          </td>
                        </tr>

                        {/*
                        <tr>
                          <td>
                            <b>Descrição:</b>
                          </td>
                          <td>{newww.description.substr(0, 500)} ...</td>
                        </tr>
            */}
                      </tbody>
                    </table>
                    <Link
                      className="btn btn-success"
                      to={`/management/news/edit/${newww.news_id}`}
                    >
                      Editar
                    </Link>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      onClick={() => deleteNews(newww.news_id)}
                      className="btn btn-primary"
                    >
                      Remover
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        : null}
    </div>
  );
};

export default NewsAdmin;
